import { makeHook } from "../../utils/makeSingleArgHook";
import { getProposalPostTradeHoldings, url, } from "../request/getTradeProposalPostTradeHoldings";
import { keyMaker as proposalKeyMaker } from "./useGetProposal";
import { TradeProposalId } from "./useGetProposals";
export { TradeProposalId };
export function keyMaker(proposalId) {
    return [...proposalKeyMaker(proposalId), url(proposalId)];
}
const useGetProposalPostTradeHoldings = makeHook(getProposalPostTradeHoldings, keyMaker);
export default useGetProposalPostTradeHoldings;
//# sourceMappingURL=useGetProposalPostTradeHoldings.js.map